import {Injectable} from '@angular/core';
import {HttpClient, HttpHandler, HttpParams} from '@angular/common/http';
import {ServiceInjector} from '@core/services/service-injector.service';
import {ResponseArray, ResponseDefault, ResponseObject} from '@shared/interfaces/http.interface';
import {HttpRequestOptions} from '@shared/interfaces/http-options.interface';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpHelper extends HttpClient {
  constructor() {
    super(ServiceInjector.injector.get(HttpHandler));
  }

  protected GetAll<T>(url: string, options?: HttpRequestOptions): Promise<ResponseArray<T>> {
    return this.get<ResponseArray<T>>(url, options).toPromise();
  }

  protected Get<T>(url: string, options?: HttpRequestOptions): Promise<ResponseObject<T>> {
    return this.get<ResponseObject<T>>(url, options).toPromise();
  }

  protected Post<T>(url: string, data: any, options?: HttpRequestOptions): Promise<ResponseDefault> {
    return this.post<ResponseDefault>(url, data, options).toPromise();
  }

  protected Put<T>(url: string, data: any): Promise<ResponseDefault> {
    return this.put<ResponseDefault>(url, data).toPromise();
  }

  protected Patch<T>(url: string, data: any): Promise<ResponseDefault> {
    return this.patch<ResponseDefault>(url, data).toPromise();
  }

  protected Delete<T>(url: string): Promise<ResponseDefault> {
    return this.delete<ResponseDefault>(url).toPromise();
  }

  protected GetFileURL(url: string, options: HttpRequestOptions = {}): Promise<string> {
    const httpOptions: HttpRequestOptions = {
      observe: 'body',
      responseType: 'blob' as 'json',
      ...options,
    };

    return this.get<Blob>(url, httpOptions)
      .pipe(map(blob => URL.createObjectURL(blob)))
      .toPromise();
  }

  protected PostFileURL(url: string, data: any): Promise<string> {
    return this.post<Blob>(url, data, {
      observe: 'body',
      responseType: 'blob' as 'json'
    })
      .pipe(map(blob => URL.createObjectURL(blob)))
      .toPromise();
  }

  /** Metoda pobierająca dane z pomocą żądania POST - na potrzeby formularzy korygujących i przesyłania hasła */
  protected GetPost<T>(url: string, data: any, options?: HttpRequestOptions): Promise<ResponseObject<T>> {
    return this.post<ResponseObject<T>>(url, data, options).toPromise();
  }

  protected getHttpParamsFromUrl(): HttpParams {
    let httpParams: HttpParams = new HttpParams();
    const urlQueryParams: URLSearchParams = new URLSearchParams(window.location.search);

    urlQueryParams.forEach((val, key) => httpParams = httpParams.append(key, val));
    return httpParams;
  }
}
